<template>
    <div class="card-container">
        <common-top-form :model="formModel" :submitService="submitService" :selectShow="true" :show="false"
                         :submitData="submitData" @success="onSuccess" :showDownloadPower="true"
                         showDownloadPowerType="purple" downloadPowerText="合计" downloadPower="/statistics/qpayInfoQry" @down="down">
            <select-organs v-model="formModel.tatSimpleId" :needAll="false"></select-organs>
            <el-form-item label="会员名称">
                <el-input v-model="formModel.userName" maxlength="20" placeholder="请输入会员名称"></el-input>
            </el-form-item>
            <el-form-item label="会员电话">
                <el-input v-model="formModel.phone" maxlength="20" placeholder="请输入会员电话"></el-input>
            </el-form-item>
            <el-form-item label="排数">
                <el-input v-model="formModel.level" maxlength="20" placeholder="请输入排数"></el-input>
            </el-form-item>
            <el-form-item label="位数">
                <el-input v-model="formModel.serialNumber" maxlength="20" placeholder="请输入位数"></el-input>
            </el-form-item>
            <el-form-item label="在途状态" prop="status">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in PlatoonLicenStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="在途类型" prop="type">
                <el-select v-model="formModel.type">
                    <el-option
                        v-for="item in PlatoonLicenTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="userName" label="会员姓名" min-width="130" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userPhone" label="手机号" min-width="130" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="money" label="在途金额（元）" min-width="130" :formatter="formatterTableNumber" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="在途状态" min-width="130" :formatter="formatterTableStatus" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="在途类型" min-width="150" :formatter="formatterTableType" show-overflow-tooltip></el-table-column>
            <el-table-column prop="typeDescribe" label="描述" min-width="160" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fromUserName" label="在途来源用户" min-width="200" :formatter="formatterTableMem" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="在途来源位置" min-width="160" :formatter="formatterTableLocation" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="在途时间" min-width="160" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <!--<el-table-column label="操作" min-width="180"  v-if="hasPerm('/tatPublicPreLicensing/reissue')">-->
                <!--<template slot-scope="scope">-->
                    <!--<el-button type="text" @click="Reissue(scope.row.id)" v-if="scope.row.status == 2">补发</el-button>-->
                    <!--<p v-else>&#45;&#45;</p>-->
                <!--</template>-->
            <!--</el-table-column>-->
        </common-table>
        <show-info-dialog title="合计" :show="true" ref="showInfoDialog" dialogWidth="400px" class="showInfoDialog">
            <p>在途金额：{{toDoubleThousands(sumMoney * 100 / 10000)}}元</p>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import ShowInfoDialog from '../../dialog/ShowInfoDialog'

    import TimeRange from 'service/constant/TimeRange'
    import MarketService from 'service/MarketService'
    import PlatoonLicenStatus from 'service/constant/PlatoonLicenStatus'
    import PlatoonLicenTypes from 'service/constant/PlatoonLicenTypes'
    import Regs from "common/conf/Regs";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "publicprelicensing",
        components: {
            CommonTopForm,
            CommonTable,
            ShowInfoDialog,
            SelectOrgans,
        },
        data() {
            return {
                formModel:{
                    tatSimpleId: '',
                    level: '',
                    serialNumber: '',
                    status: '',
                    type: '',
                    phone: '',
                    userName: '',
                    time: TimeRange.monthRange,
                },
                submitService: MarketService.tatPublicPreLicensing,
                tableData: [],
                isPage: false,
                page: {},
                sumMoney: 0,
                PlatoonLicenStatus:PlatoonLicenStatus,
                PlatoonLicenTypes:PlatoonLicenTypes
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    level: this.formModel.level,
                    serialNumber: this.formModel.serialNumber,
                    userPhone: this.formModel.phone,
                    userName: this.formModel.userName,
                    status: this.formModel.status,
                    type: this.formModel.type,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;

            this.getList();
        },
        methods: {
            down(){
                this.doLoad(MarketService.sumMoney,this.submitData,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.sumMoney = result;
                        this.$refs.showInfoDialog.open();
                    });
                },'信息获取失败')
            },
            formatterTableLocation(row, column, cellValue, index){
                return `第${row.level}排 第${row.serialNumber}位`;
            },
            formatterTableMem(row, column, cellValue, index){
                return row.fromUserName + ' - ' + row.fromUserPhone;
            },
            formatterTableStatus(row, column, cellValue, index){
                let value = '';
                this.PlatoonLicenStatus.forEach(item => {
                    if (item.value == cellValue){
                        value = item.label
                    }
                });
                return value ? value : '--';
            },
            formatterTableType(row, column, cellValue, index){
                let value = '';
                this.PlatoonLicenTypes.forEach(item => {
                    if (item.value == cellValue){
                        value = item.label
                    }
                });
                return value ? value : '--';
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    }, '信息获取失败'
                )
            },
            doReissue(id) {
                this.doLoad(MarketService.licenReissue, {
                    id: id
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            Reissue(id) {
                this.showConfirm(`确定对该记录进行补发操作？`).then(() => {
                    this.doReissue(id)
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/PublicPreLicensing.vue